import http from './public'
// 登陆
export const userLogin = (params) => {
  return http.fetchPost('/user/login', params)
}
// 退出登陆
export const logout = (params) => {
  return http.fetchPost('/user/logout', params)
}
// 用户信息
export const userInfo = (params) => {
  return http.fetchPost('/user/checkLogin', params)
}
// 注册账号
export const register = (params) => {
  return http.fetchPost('/user/register', params)
}
// 上传图片
export const upload = (params) => {
  return http.fetchPost('/upload/upload', params)
}
// 修改头像
export const updateheadimage = (params) => {
  return http.fetchPost('/member/updateheadimage', params)
}
// 首页接口
export const bannerList = (params) => {
  return http.fetchPost('/index/banner', params)
}
// 首页接口
export const categoryList = (params) => {
  return http.fetchPost('/index/category', params)
}
// 首页接口
export const factoryList = (params) => {
  return http.fetchPost('/index/factory', params)
}
// 捐赠板块
export const thank = (params) => {
  return http.fetchGet('/goods/thank', params)
}
// 手机验证
export const captcha = (params) => {
  return http.fetchPost('/user/smscode', params)
}
// 重置密码
export const findPassword = (params) => {
  return http.fetchPost('/user/findPwd', params)
}
// 被推荐人
export const relationship = (params) => {
  return http.fetchGet('/user/relationship', params)
}
// 推广主题列表
export const topicExtendList = (params) => {
  return http.fetchGet('/extension/topicExtension', params)
}
// 收入明细
export const receiveAmount = (params) => {
  return http.fetchGet('/user/receiveAmount', params)
}
// 修正密码
export const updatePwd = (params) => {
  return http.fetchPost('/user/updatePwd', params)
}
// 获取openid
export const userWeixinOpenid = (params) => {
  return http.fetchPost('/user/userWeixinOpenid', params)
}
// 分享者临时保存
export const shareUser = (params) => {
  return http.fetchPost('/user/shareUser', params)
}
// 实名信息密码
export const updateRealInfo = (params) => {
  return http.fetchPost('/user/updateRealInfo', params)
}
// 绑定微信
export const bindWeixin = (params) => {
  return http.fetchPost('/user/bindWeixin', params)
}
// 分享者信息
export const shareUserInfo = (params) => {
  return http.fetchPost('/user/shareUserInfo', params)
}



// WEBPACK FOOTER //
// ./src/api/index.js